import { create } from "zustand";

export type CancellationStep =
  | "comparison"
  | "reason"
  | "offer"
  | "feedback"
  | "thank_you"
  | "alternative_feedback"
  | "no_longer_need_reason"
  | "pause_timeframe"
  | "other_reason_feedback";

export type NoLongerNeedReason =
  | "graduated"
  | "exam_over"
  | "taking_break"
  | "other_reason";

type CancellationModalStore = {
  isOpen: boolean;
  step: CancellationStep;
  selectedReason: string | null;
  noLongerNeedReason: NoLongerNeedReason | null;
  feedbackSubmitted: boolean;
  feedbackText: string | null;
  feedbackRating: number | null;
  setStep: (step: CancellationStep) => void;
  setReason: (reason: string) => void;
  setNoLongerNeedReason: (reason: NoLongerNeedReason) => void;
  setFeedbackSubmitted: (text?: string, rating?: number) => void;
  onOpen: () => void;
  onClose: () => void;
};

const useCancellationModal = create<CancellationModalStore>((set) => ({
  isOpen: false,
  step: "comparison",
  selectedReason: null,
  noLongerNeedReason: null,
  feedbackSubmitted: false,
  feedbackText: null,
  feedbackRating: null,
  setStep: (step) => set({ step }),
  setReason: (reason) => set({ selectedReason: reason }),
  setNoLongerNeedReason: (reason) => set({ noLongerNeedReason: reason }),
  setFeedbackSubmitted: (text?: string, rating?: number) =>
    set({
      feedbackSubmitted: true,
      feedbackText: text ?? null,
      feedbackRating: rating ?? null,
    }),
  onOpen: () =>
    set({
      isOpen: true,
      step: "comparison",
      selectedReason: null,
      noLongerNeedReason: null,
      feedbackSubmitted: false,
      feedbackText: null,
      feedbackRating: null,
    }),
  onClose: () =>
    set({
      isOpen: false,
      step: "comparison",
      selectedReason: null,
      noLongerNeedReason: null,
      feedbackSubmitted: false,
      feedbackText: null,
      feedbackRating: null,
    }),
}));

export default useCancellationModal;
